import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Modal, Form, message } from "antd";
import { useContext, useEffect } from "react";
import { handleApproveChangeRequest } from "../../../api/requests";
import { AuthContext } from "../../../contexts/AuthContext";

export default function ApproveRequest({
  isVisible,
  setVisible,
  selected,
}: any) {
  const { user } = useContext(AuthContext);
  const { _id } = selected;
  const queryClient = useQueryClient();
  const [form] = Form.useForm();

  const options = [
    { label: "Approve", value: "approve" },
    { label: "Reject", value: "reject" },
  ];

  const { mutate } = useMutation({
    mutationFn: handleApproveChangeRequest,
    onSuccess: () => {
      message.success("Approved Successfully");
      form.resetFields();
      queryClient.invalidateQueries({ queryKey: ["requests"] });
      queryClient.invalidateQueries({ queryKey: ["unitRequests"] });
    },
    onError: () => {
      message.error("Something went wrong");
    },
  });

  const onSubmit = async (status: string) => {
    const data = { userId: user?._id, status };
    await mutate({ _id, data });
    setVisible(false);
  };

  useEffect(() => {
    form.resetFields();
  }, [selected, form]);

  return (
    <Modal
      open={isVisible}
      title="Approve Change Request"
      onCancel={() => setVisible(false)}
      footer={null}
    >
      <Form
        id="approveChangeRequest"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
        layout="vertical"
      >
        <Form className="flex flex-col items-center justify-center my-8">
          <div className="font-bold text-black text-xl">Approve Change Request</div>
          <div className="text-gray-700 capitalize">
            <span className="font-bold">Project:</span> {selected?.projectName}
          </div>
          <div className="text-gray-700 capitalize">
            <span className="font-bold">Business Unit:</span> {selected?.businessUnit?.name || "-"}
          </div>
          <Form className="flex items-center gap-2 mt-4">
            {options?.map((option: any) => (
              <button
                key={option?.value}
                onClick={() => onSubmit(option?.value)}
                className={`border px-2 py-1 bg-gray-100 shadow-sm w-24 text-center ${option?.value === "approve"
                  ? "bg-green-500 text-white"
                  : "bg-red-500 text-white  border-red-500  "
                  }`}
              >
                {option?.label}
              </button>
            ))}
          </Form>
        </Form>
      </Form>
    </Modal>
  );
}
